/**
 * アプリケーションのサービス開始日（機能提供開始月の初日）
 */
export const APP_SERVICE_START_DATE = new Date(2020, 8, 1);
